import { ChangeDetectorRef, Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import {
  CtBinaryOperator, CtButtonConfiguration,
  CtControlConfiguration,
  CtControlTypes,
  CTDatatablePaginationParameter,
  CtFormConfiguration, CTGeneralService,
  CtModelConfiguration,
  CTModelDatatableFilter,
  CtModelDatatableOperators,
  CtSelectControlOptions,
  CtSelectControlValue,
  CtSortOrderDescriptorParameter,
  CtThemeTypes, MAT_RAISED_ACCENT, MAT_RAISED_PRIMARY, MAT_RAISED_WARN,
  MateriaHintExtensionConfig,
  MaterialControlOptions,
} from "@ctsolution/ct-framework";
import { FormBuilder } from "@angular/forms";
import { CTWorkOrder } from "../../../../../_core/classes/ct-work-order";
import { WorkOrderService } from "../../../work-order.service";
import { CTMWorkOrderViewType } from "../../../../../_core/enum/work-order-type";
import { GeneralDataConfiguration } from "./general-data.configuration";
import { CtWebapiGenericResponse, DataRequest, MethodEnum } from "@ctsolution/ct-webapi";
import { CtWorkOrderInformationContent } from "../../../../../_core/classes/ct-work-order.information-content";
import { WorkOrderImportParameter } from "../../../../../_core/classes/work-order-import.parameter";
import { WorkOrderController } from "../../../../../_core/controllers/work-order.controller";
import { WorkOrderFileImportParameter } from "../../../../../_core/classes/work-order-xml-import.parameter";
import { CTMGeneralService } from 'projects/ct-manager/src/app/_core/lib/general.service';
import { debounceTime, distinctUntilChanged } from "rxjs";
import {
  WorkOrderImportFileConfigurationDialogService
} from "../../work-order-import-file-configuration-dialog/work-order-import-file-configuration-dialog.service";
import { WorkOrderAttachmentsService } from './work-order-attachments.service';
import { LeadRedirectButtonConfiguration } from "./lead-redirect-button/lead-redirect-button.configuration";
import { WorkOrderStatusEnum } from 'projects/ct-manager/src/app/_core/enum/work-order-state';
import { CtManagerService } from 'projects/ct-manager/src/app/_core/lib/ct-manager.service';
import { ActivatedRoute } from '@angular/router';
import { WorkOrderRouteData } from 'projects/ct-manager/src/app/_core/route-data/work-order.route-data';
import { CTConfigurationModel } from 'projects/ct-manager/src/app/_core/classes/ct-configuration-model';
import { CustomCtFormContainerHelper } from 'projects/ct-manager/src/app/_core/services/custom-ct-form.helper';
import { CTCompany } from 'projects/ct-manager/src/app/_core/classes/ct-company';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { WorkOrderNameChangeWarningDialogComponent, WorkOrderNameChangeWarningResult } from '../work-order-name-change-warning-dialog/work-order-name-change-warning-dialog.component';
import { WorkOrderDuplicateNameDialogComponent, WorkOrderDuplicateNameDialogData } from '../work-order-duplicate-name-dialog/work-order-duplicate-name-dialog.component';

@Component({
  selector: 'ctm-general-data',
  templateUrl: './general-data.component.html',
  providers: [WorkOrderController]
})
export class GeneralDataComponent {

  @Output() onSubmit: EventEmitter<Date | null> = new EventEmitter<Date | null>();
  @Input() configuration: GeneralDataConfiguration | null = null;
  @Input() creaPackagingButtonConfiguration: CtButtonConfiguration | null = null;
  //input creaPackagingButtonConfiguration

  formConfiguration: CtFormConfiguration | null = null;
  leadButtonConfiguration: LeadRedirectButtonConfiguration | null = null;
  isNotClosedState = true;
  workOrderConfiguration: CtModelConfiguration<any> | null = null;
  workOrderDynamicFormConfiguration: CTConfigurationModel = CTConfigurationModel.create();
  workOrderNameControl: CTConfigurationModel = CTConfigurationModel.create();
  companyInformation: CTCompany | null = null;
  companyInformationConfiguration: CTConfigurationModel = CTConfigurationModel.create().setVisible(false);
  workOrderCheckName: CTConfigurationModel = CTConfigurationModel.create().setVisible(false);


  /**
   * Valore originale del campo Name al caricamento del work order
   * Viene utilizzato per confrontare se il nome è stato modificato prima della submit
   */
  private originalNameValue: string | null = null;

  get isQuotation() {

    return this.configuration?.workOrderType === CTMWorkOrderViewType.Quotation;

  }

  cancelButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("CT_PAGE.CT_FORM.cancel")
    .setAction(() => this.CTGeneralService.back())
    .setMatherialOptions(MAT_RAISED_WARN);

  acceptQuotationButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("AcceptQuotation")
    .setAction(() => {

      this.formConfiguration?.form?.markAllAsTouched();
      this.onSubmit.emit(new Date());

    })
    .setMatherialOptions(MAT_RAISED_PRIMARY);

  submitButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("CT_PAGE.CT_FORM.save")
    .setClass('ct-model-submit-button')
    .setAction(() => {

      this.formConfiguration?.form?.markAllAsTouched();
      
      // Verifica se il controllo del nome è abilitato e se il nome è stato modificato
      this.handleNameChangeBeforeSubmit();

    })
    .setMatherialOptions(MAT_RAISED_ACCENT);

  private workOrderStateLookup = this.generalService.getLookupControlDefaultConfiguration({
    name: 'State',
    controller: 'WorkOrderState',
    type: CtControlTypes.ENUMERABLE
  }).setLabel('WorkOrderState');

  private customerLookup = this.generalService.getLookupControlDefaultConfiguration({
    name: 'Company',
    controller: 'Company',
    key: 'ReferenceName'
  })
    .configureOptions<CtSelectControlOptions>(options => {

      if (!options) options = CtSelectControlOptions.create();

      options
        .setLookupFilter(value => {

          const filters: CTModelDatatableFilter[] = [
            CTModelDatatableFilter.create().setField('IsCustomer').setValue(true).setOperatorType(CtBinaryOperator.Equal),
          ];

          if (value) {

            filters.push(CTModelDatatableFilter.create().setField('ReferenceName').setValue(value).setOperatorType(CtBinaryOperator.Contains))

          }

          filters.push(this.customCtFormContainerHelper.getFilterForLookupCompanyOrContact(this.customerLookup));

          const operators = CtModelDatatableOperators.create().setFilters(filters);

          operators
            .Pagination
            ?.setSortOrders(new Array<CtSortOrderDescriptorParameter>(CtSortOrderDescriptorParameter.create('ReferenceName')))

          return operators;

        })
        .setEnableAddOptionButton(true)
        .setOnAddOptionButtonClick(() => new Promise<CtWebapiGenericResponse<number> | null>((resolve) => {

          this.workOrderService
            .createCustomer()
            .then((result) => {

              if (result.Oid) {

                this.generalService.getInfos({ controller: 'company', oid: result.Oid }).subscribe((response: CtWebapiGenericResponse<any>) => {

                  const res = response.Result.DataSource;
                  const label = res.ReferenceName ?? res.Name + res.Surname;

                  setTimeout(() => {

                    this.customerLookup
                      ?.setValue(
                        CtSelectControlValue
                          .create()
                          .setLabel(label)
                          .setValue(result.Oid))

                  }, 100)

                });

              }

              resolve(result)

            })

        }))

    }).setLabel('Customer');

  private addressLookup = this.generalService.getLookupControlDefaultConfiguration({
    name: "Address",
    controller: "CompanyPlace"
  })
    .setFlexSpacePercentage(100)
    .configureOptions<CtSelectControlOptions>(options => {

      if (!options) options = CtSelectControlOptions.create();

      options
        ?.setForceSelection(false)
        ?.setLookupFilter(value => {

          const filters: CTModelDatatableFilter[] = [];

          const customerControl = this.customerLookup.control;

          if (customerControl?.valid) {

            const customerControlValue = customerControl.value;
            const customerOid = customerControlValue?.value;

            filters.push(CTModelDatatableFilter.create().setField('Company.Oid').setValue(customerOid).setOperatorType(CtBinaryOperator.Equal));

          } else {

            customerControl?.markAsTouched();

          }

          if (value) {

            filters.push(CTModelDatatableFilter.create().setField('Name').setValue(value).setOperatorType(CtBinaryOperator.Contains))

          }

          const operators = CtModelDatatableOperators.create().setFilters(filters);

          operators
            .Pagination
            ?.setSortOrders(new Array<CtSortOrderDescriptorParameter>(CtSortOrderDescriptorParameter.create('Name')))

          return operators;

        })

    });
  private extraDataJsonControl = CtControlConfiguration
    .create()
    .setRemoteValueOptionsEndpoint(
      DataRequest
        .create()
        .setUrl(`/SpecificInfoWorkOrder/FieldsByType/1?hideSpinner=true`) //TODO: Da rivedere perché viene chiamata sempre anche se non neccessaria 
        .setMethod(MethodEnum.POST)
        .setBody({}))
    .setLabel('ExtraDataJSON')
    .setName('ExtraDataJSON')
    .setType(CtControlTypes.EXTRA_DATA);

  private nameControl = this.generalService.getTextControl({
    name: 'Name',
    required: true,
    flexSpacePercentage: 50
  }).setLabel('ReferenceNameWorkOrder')

  private codeControl = this.generalService.getTextControl({
    name: 'Code',
    required: false,
    flexSpacePercentage: 50
  })

  /**
   * Array di controlli base per i quotation/work order
   * NOTA: nameControl viene aggiunto dinamicamente solo se workOrderNameControl.visible = true
   */
  private genericQuotationControls: CtControlConfiguration[] = [];

  private genericWorkOrderAdditionalControls = [
    this.generalService.getDateControlDefault({ name: 'StartAt', required: false, flexSpacePercentage: 50 }).setNullValueEnabled(true).setLabel('SupplyStartDate'),
    this.generalService.getDateControlDefault({
      name: 'ExpiredAt',
      required: false,
      flexSpacePercentage: 50
    }).setNullValueEnabled(true).setLabel('SupplyExpirationDate'),
  ]

  constructor(
    private cdr: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private ctManagerService: CtManagerService,
    private CTGeneralService: CTGeneralService,
    private generalService: CTMGeneralService,
    private workOrderService: WorkOrderService,
    private workOrderController: WorkOrderController,
    private workOrderImportFileConfigurationDialogService: WorkOrderImportFileConfigurationDialogService,
    private workOrderAttachments: WorkOrderAttachmentsService,
    private route: ActivatedRoute,
    private customCtFormContainerHelper: CustomCtFormContainerHelper,
    private dialog: MatLegacyDialog) { }

  async ngAfterViewInit() {

    const pId = this.route.snapshot.paramMap.get("id");

    if (pId) {

      this.workOrderConfiguration = CtModelConfiguration.create<any>().setRouteData(WorkOrderRouteData().setId(+pId))

    }

    
    await this.ctManagerService.getComponentOverride("workOrder", "workOrderDynamicFormConfiguration", this.workOrderDynamicFormConfiguration).then((component) => {
      return;
    });

    await this.ctManagerService.getComponentOverride("workOrder", "workOrderNameControl", this.workOrderNameControl).then((component) => {
      return;
    });


    await this.ctManagerService.getComponentOverride("workOrder", "companyInformationConfiguration", this.companyInformationConfiguration).then((component) => {
      return;
    });

    await this.ctManagerService.getComponentOverride("workOrder", "workOrderCheckName", this.workOrderCheckName).then((component) => {
      return;
    });

    // Costruisce dinamicamente l'array dei controlli in base alla configurazione
    this.buildGenericQuotationControls(pId);
    
    const controls = this.genericQuotationControls;


    if(this.isQuotation) this.workOrderDynamicFormConfiguration.visibleWorkOrder = true;

    if (this.isQuotation) {

      if (this.configuration?.nameQuotationHint) {

        const materialOptions = this.nameControl.materialOptions;

        if (!materialOptions) {

          this.nameControl.setMaterialOptions(MaterialControlOptions.create());

        }

        this.nameControl.materialOptions?.setHint(MateriaHintExtensionConfig.create().setMessage(this.configuration?.nameQuotationHint))

      }

      if (this.configuration?.codeQuotationHint) {

        const materialOptions = this.codeControl.materialOptions;

        if (!materialOptions) {

          this.codeControl.setMaterialOptions(MaterialControlOptions.create());

        }

        this.codeControl.materialOptions?.setHint(MateriaHintExtensionConfig.create().setMessage(this.configuration?.codeQuotationHint))

      }

      this.nameControl.setLabel('ReferenceNameWorkOrderQuotation');


    }

    switch (this.configuration?.workOrderType) {

      case CTMWorkOrderViewType.Standard:

        if (this.configuration.extraDataJsonEnabled) {

          this.genericWorkOrderAdditionalControls
            .push(this.extraDataJsonControl);

        }

        controls
          .push(...this.genericWorkOrderAdditionalControls);

        break;
      default:
        break;

    }

    if (this.configuration?.enableExtraDataQuotation && (this.configuration?.workOrderType == CTMWorkOrderViewType.Quotation)) { //configurazione che permette ai preventivi di avere i genericWorkOrderAdditionalControls

      controls
        .push(...this.genericWorkOrderAdditionalControls);

    }

    this.formConfiguration = CtFormConfiguration
      .create(this.formBuilder.group({}))
      .setTheme(CtThemeTypes.MATERIAL)
      .setControls(controls);

    this.customerLookup
      .control
      ?.valueChanges
      .pipe(
        debounceTime(100),
        distinctUntilChanged())
      .subscribe(() => {
        this.addressLookup.setValue(null);
        this.addressLookup.setValue('');
      });

    if (this.configuration?.WorkOrder?.Oid) {

      this.leadButtonConfiguration = LeadRedirectButtonConfiguration
        .create()
        .setWorkOrderOid(this.configuration?.WorkOrder?.Oid);

    }

    await this.generalService.syncMissingControls(this.genericQuotationControls, WorkOrderRouteData(), this.formConfiguration);

    this.cdr.detectChanges();

  }

  import(event: any) {

    const files = (event.target as HTMLInputElement).files ?? [];

    if (!files.length) return;

    const file = files[0];

    const filters: CTModelDatatableFilter[] = [];
    const pagination = new CTDatatablePaginationParameter(1, 100);


    this.generalService.getList({

      controller: "FileImportConfiguration",
      filters: filters,
      pagination: pagination

    }).subscribe((response: CtWebapiGenericResponse<any>) => {


      if (!response.Result.DataSource || response.Result.DataSource.length < 1) return;

      const result = response.Result.DataSource;

      if (result.length === 1) this.importFile(file, result[0].Code);
      else this.importFile(file, null);



    })
  }

  private importFile(file: File, code: string | null) {

    if (!this.configuration?.WorkOrder.Oid) return;

    this.workOrderImportFileConfigurationDialogService
      .open()
      .afterClosed()
      .subscribe((result: any | null) => {

        if (result.Code == null) result.Code = code;

        if (result.Code) {

          const parameter: WorkOrderFileImportParameter = WorkOrderFileImportParameter
            .create()
            .setWorkOrderOid(+this.configuration!.WorkOrder.Oid)
            .setFile(file)
            .setCode(result.Code)
            .setOverwriteSameCodeItems(result.OverwriteSameCodeItems);

          this.workOrderController.importItemsFromFile(parameter)
            .subscribe({
              next: () => {

                this.reloadCurrentPath();

              }

            })

        }

      })

  }

  private importGenericFile(file: File) {

    if (!this.configuration?.WorkOrder.Oid) return;

    const parameter: WorkOrderImportParameter = WorkOrderImportParameter
      .create()
      .setWorkOrderOid(+this.configuration.WorkOrder.Oid)
      .setFile(file);

    this.workOrderController
      .importItems(parameter)
      .subscribe({
        next: (response: any) => {

          if (!response.Result) return;

          const result: WorkOrderImportErrorsResult = response.Result;

          if (result.Errors.length > 0) {
            this.workOrderService.errorsDialog(result).then(() => {
              if (result.ImportIsValid) this.reloadCurrentPath();
            }).catch(error => {
              console.error("Errore nella chiusura della dialog:", error);
            });
          } else {
            this.reloadCurrentPath();
          }

        }

      })

  }

  private reloadCurrentPath(): void {

    let currentPath = window.location.pathname;

    const hasQuestionMark = currentPath.includes('?');

    if (!hasQuestionMark) currentPath += '?rows=true';

    window.location.href = window.location.origin + currentPath;

  }

  setup(model: CTWorkOrder<CtWorkOrderInformationContent> | null) {

    if (!model) return;

    if (model.Company) this.companyInformation = model.Company;

    // Salva il valore originale del nome per il controllo successivo
    if (model.Name) {
      this.originalNameValue = model.Name;
    }

    this.formConfiguration?.form?.patchValue(model);

    if (model.State) {

      this.formConfiguration?.form?.get('State')?.setValue(model.State.Oid);

      this.isNotClosedState = model.State.Type != WorkOrderStatusEnum.Closed;

    }

    if (model.ExpiredAt) {

      this.formConfiguration?.form?.get('ExpiredAt')?.setValue(model.ExpiredAt);

    }

    if (model.StartAt) {

      this.formConfiguration?.form?.get('StartAt')?.setValue(model.StartAt);

    }

    if (model.Company) {

      this.customerLookup
        .setValue(
          CtSelectControlValue
            .create()
            .setLabel(model.Company.ReferenceName)
            .setValue(model.Company.Oid))

    }

    if (model.Address) {

      setTimeout(() => {

        this.addressLookup
          .setValue(
            CtSelectControlValue
              .create()
              .setLabel(model.Address)
              .setValue(model.Address))

      }, 100)

    }

    this.cdr.detectChanges();

  }

  async PutFileAttachments() {

    const ref = await this.workOrderAttachments.open(this.configuration?.WorkOrder);

    ref
      .afterClosed()
      .subscribe(result => {

        (event as any)['FilesAttachedCount'] = result ?? 0

      })

  }

  /**
   * Costruisce dinamicamente l'array genericQuotationControls
   * Il nameControl viene aggiunto solo se workOrderNameControl.visible = true
   */
  private buildGenericQuotationControls(pid : string | null): void {
    
    // Reset dell'array per evitare duplicati
    this.genericQuotationControls = [];

    // Aggiungi il nameControl SOLO se la configurazione lo richiede
    if (this.workOrderNameControl.visible || pid != null) {
      this.genericQuotationControls.push(this.nameControl);
    }else{

      this.addressLookup.setFlexSpacePercentage(50);

    }

    // Aggiungi sempre gli altri controlli
    this.genericQuotationControls.push(
      this.codeControl,
      this.workOrderStateLookup,
      this.customerLookup,
      this.addressLookup,
      this.generalService.getTextControl({ name: 'Description' })
        .setType(CtControlTypes.TEXTAREA)
        .setFlexSpacePercentage(100)
        .setLabel('DescriptionWorkOrderControl')
    );
  }

  /**
   * Gestisce tutti i controlli prima della submit.
   * 
   * Se workOrderCheckName.visible = true:
   *   1. Controllo duplicati nome (BLOCCANTE)
   *   2. Controllo modifica nome (WARNING non bloccante)
   *   3. Submit
   * 
   * Se workOrderCheckName.visible = false:
   *   - Submit diretta senza controlli
   */
  private async handleNameChangeBeforeSubmit(): Promise<void> {
    
    // Se il controllo del nome è disabilitato, procedi direttamente con la submit
    if (!this.workOrderCheckName.visible) {
      this.onSubmit.emit();
      return;
    }

    // STEP 1: Controllo duplicati nome (BLOCCANTE)
    const currentNameValue = this.formConfiguration?.form?.get('Name')?.value;
    
    if (currentNameValue) {
      const isDuplicate = await this.checkDuplicateName(currentNameValue);
      
      if (isDuplicate) {
        // Mostra dialog di errore e blocca la submit
        this.showDuplicateNameErrorDialog(currentNameValue);
        return; // BLOCCA la submit
      }
    }

    // STEP 2: Controllo modifica nome (WARNING, non bloccante)
    // Questo controllo viene fatto solo se nameControl è visibile
    // Verifica se il nome è stato modificato
    const hasNameChanged = this.hasNameBeenModified(currentNameValue);

    // Se il nome non è stato modificato, procedi direttamente
    if (!hasNameChanged) {
      this.onSubmit.emit();
      return;
    }

    // Verifica se l'utente ha scelto di nascondere il warning
    if (WorkOrderNameChangeWarningDialogComponent.shouldHideWarning()) {
      // L'utente ha scelto "non mostrare più", procedi senza modale
      this.onSubmit.emit();
      return;
    }

    // Il nome è stato modificato e il warning non è stato disabilitato: mostra la modale
    // NOTA: Non fare this.onSubmit.emit() qui! La modale gestisce la submit dopo la conferma
    this.showNameChangeWarningDialog();
  }

  /**
   * Controlla se esiste già un work order con lo stesso nome nel sistema
   * @param nameToCheck - Nome da verificare
   * @returns Promise<boolean> - true se esiste un duplicato, false altrimenti
   */
  private async checkDuplicateName(nameToCheck: string): Promise<boolean> {
    
    // Normalizza il valore per il confronto case-insensitive
    const normalizedName = (nameToCheck ?? '').trim();
    
    // Se il nome è vuoto, non fare il controllo
    if (!normalizedName) {
      return false;
    }

    try {
      // Crea i filtri per la ricerca
      const filters: CTModelDatatableFilter[] = [];

      // Filtro per il nome (case-insensitive usando Contains)
      filters.push(
        CTModelDatatableFilter
          .create()
          .setField('Name')
          .setValue(normalizedName)
          .setOperatorType(CtBinaryOperator.Equal)
      );

      // Se siamo in modalità EDIT, escludi il work order corrente dalla ricerca
      const currentWorkOrderOid = this.configuration?.WorkOrder?.Oid;
      if (currentWorkOrderOid) {
        filters.push(
          CTModelDatatableFilter
            .create()
            .setField('Oid')
            .setValue(currentWorkOrderOid)
            .setOperatorType(CtBinaryOperator.NotEqual)
        );
      }

      // Configurazione degli operatori
      const operators = CtModelDatatableOperators.create().setFilters(filters);
      
      // Paginazione: ci basta sapere se esiste almeno 1 record
      const pagination = new CTDatatablePaginationParameter(1, 1);

      // Esegui la chiamata al backend
      const response = await this.generalService.getList({
        controller: "WorkOrder",
        filters: filters,
        pagination: pagination
      }).toPromise();

      // Controlla se ci sono risultati
      const dataSource = response?.Result?.DataSource;
      const hasDuplicates = dataSource && dataSource.length > 0;

      return hasDuplicates;

    } catch (error) {
      // In caso di errore nella chiamata, logga e non bloccare la submit
      console.error('Errore durante il controllo duplicati nome:', error);
      return false; // Non bloccare la submit in caso di errore
    }
  }

  /**
   * Mostra la modale di errore per nome duplicato
   * @param duplicateName - Nome duplicato rilevato
   */
  private showDuplicateNameErrorDialog(duplicateName: string): void {
    
    const dialogData: WorkOrderDuplicateNameDialogData = {
      duplicateName: duplicateName,
      duplicateCount: 1
    };

    this.dialog.open(WorkOrderDuplicateNameDialogComponent, {
      width: '500px',
      disableClose: true, // Dialog bloccante - l'utente DEVE chiuderlo
      autoFocus: true,
      data: dialogData
    });
    
    // Non è necessario gestire l'afterClosed perché questo dialog è solo informativo
    // L'utente chiude il dialog e rimane sulla pagina per correggere il nome
  }

  /**
   * Gestisce il controllo della modifica del nome prima della submit.
   * Se il controllo è abilitato e il nome è stato modificato, mostra la modale di warning.
   * Altrimenti procede direttamente con la submit.
   * 
   * @deprecated Questo metodo è stato integrato in handleNameChangeBeforeSubmit
   */
  private handleNameChangeBeforeSubmit_OLD(): void {
    
    // Se il controllo non è abilitato, procedi direttamente con la submit
    if (!this.workOrderNameControl.visible) {
      this.onSubmit.emit();
      return;
    }

    // Verifica se il nome è stato modificato
    const currentNameValue = this.formConfiguration?.form?.get('Name')?.value;
    const hasNameChanged = this.hasNameBeenModified(currentNameValue);

    // Se il nome non è stato modificato, procedi direttamente
    if (!hasNameChanged) {
      this.onSubmit.emit();
      return;
    }

    // Verifica se l'utente ha scelto di nascondere il warning
    if (WorkOrderNameChangeWarningDialogComponent.shouldHideWarning()) {
      // L'utente ha scelto "non mostrare più", procedi senza modale
      this.onSubmit.emit();
      return;
    }

    // Il nome è stato modificato e il warning non è stato disabilitato: mostra la modale
    this.showNameChangeWarningDialog();
  }

  /**
   * Verifica se il valore del campo Name è stato modificato rispetto all'originale
   * @param currentValue - Il valore attuale del campo Name
   * @returns true se il nome è stato modificato, false altrimenti
   */
  private hasNameBeenModified(currentValue: string | null | undefined): boolean {
    
    // Se non c'è un valore originale (nuovo work order), non c'è modifica
    if (!this.originalNameValue) {
      return false;
    }

    // Se il valore corrente è null/undefined/empty string, consideralo come stringa vuota
    const normalizedCurrentValue = (currentValue ?? '').trim();
    const normalizedOriginalValue = this.originalNameValue.trim();

    // Confronta i valori normalizzati
    return normalizedCurrentValue !== normalizedOriginalValue;
  }

  /**
   * Apre la modale di warning per la modifica del nome.
   * Se l'utente conferma, procede con la submit.
   * Se l'utente annulla, non fa nulla (rimane sulla pagina).
   */
  private showNameChangeWarningDialog(): void {
    
    const dialogRef = this.dialog.open(WorkOrderNameChangeWarningDialogComponent, {
      width: '500px',
      disableClose: false, // Permette la chiusura cliccando fuori o premendo ESC
      autoFocus: true
    });

    dialogRef
      .afterClosed()
      .subscribe((result: WorkOrderNameChangeWarningResult | undefined) => {
        
        // Se l'utente ha confermato, procedi con la submit
        if (result?.confirmed) {
          this.onSubmit.emit();
        }
        
        // Se l'utente ha annullato, non fa nulla (rimane sulla pagina)
        // Non è necessario gestire esplicitamente l'annullamento
      });
  }

}

export class WorkOrderImportErrorsResult {

  Errors: any[] = [];
  ImportIsValid: boolean;

  private constructor(errors: any[], impostIsValid: boolean) {

    this.Errors = errors;
    this.ImportIsValid = impostIsValid;

  }

}
